export default "__VITE_ASSET__DtEuDfX4__"